import * as React from 'react';
import { connect } from 'react-redux';
import { push } from "connected-react-router";
import { Login, Logout } from '../redux/actions/AuthActions';
import { Button, Col, Label } from "reactstrap";
import { IStore } from '../redux/constants';
import { withTranslation } from 'react-i18next';

declare var require: any

const Page404img = require("../Assets/imgs/Page404.png") as string;

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history, URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme
});

const dispatchProps = { push, Login, Logout }
export interface Page404Props {
    lang: string;
    userData: any;
    push: any;
    URL: string;
    theme: any
    isAuth: boolean;
    isAdmin: boolean;
    path: any;
    t: any;
}

export interface Page404State {
}

class Page404 extends React.Component<Page404Props, Page404State> {
    componentDidMount() {
        if (this.props.path !== undefined && this.props.path !== null && (this.props.path === "" || this.props.path === "/")) {
            if (!this.props.isAuth) {
                this.props.push('/login');
            } else {
                this.props.push('/Documentation');
            }
        }
    }
    state = {

    }
    navigate = () => {
        if (this.props)
            this.props.push('/login');
    }
    render() {
        return (
            <div className=" mainExternal signin heightSighnIn extraHeight">
                <div className="container">
                    <div className="row py-5 align-items-center">
                        <Col sm="10" md="10" lg="10" className="mx-auto d-table h-100 containerMsg">
                            <div className=" text-center p10" >
                                <img src={Page404img} alt="" className="mt-3" />
                                <div className="d-block mt-3 text-center m10 align-self-center justify-content-center">
                                    <Label className="text-Grey font-32 t-bold d-block mb-2">  {this.props.t('PageNotFound')} </Label>
                                    <Label className="text-Grey font-24 d-block m-0"> {this.props.t("Page404Text")} </Label>
                                    <Button className="SessionBtn mt-3 mb-3" onClick={this.navigate}>
                                        {this.props.t('GoBack')}</Button>
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(Page404));
